const theme = {
    // Should use RGBA here as HEX doesn't play well with PDF generation
    colors: {
        navy: 'rgba(0, 5, 70, 1)',
        navy10: 'rgba(0, 5, 70, 0.1)',
        navy20: 'rgba(0, 5, 70, 0.2)',
        navy40: 'rgba(0, 5, 70, 0.4)',
        navy60: 'rgba(0, 5, 70, 0.6)',
        navy80: 'rgba(0, 5, 70, 0.8)',
        xLightGrey: 'rgba(246, 246, 255, 1)',
        lightGrey: 'rgba(231, 230, 243, 1)',
        mediumGrey: 'rgba(171, 170, 186, 1)',
        darkGrey: 'rgba(136, 134, 151, 1)',
        dark: 'rgba(41, 41, 41, 1)',
        lightNavy: 'rgba(21, 32, 107, 1)',
        lightNavyHover: 'rgba(72, 78, 129, 1)',
        orange: 'rgba(252, 82, 23, 1)',
        orange80: 'rgba(252, 82, 23, 0.8)',
        orange60: 'rgba(252, 82, 23, 0.6)',
        orange40: 'rgba(252, 82, 23, 0.4)',
        orange20: 'rgba(252, 82, 23, 0.2)',
        orange10: 'rgba(252, 82, 23, 0.1)',
        darkRed: 'rgba(153, 0, 11, 1)',
        redDark: 'rgba(153, 0, 11, 1)',
        red: 'rgba(242, 0, 18, 1)',
        red80: 'rgba(242, 0, 18, .8)',
        red60: 'rgba(242, 0, 18, .6)',
        red40: 'rgba(242, 0, 18, .4)',
        red20: 'rgba(242, 0, 18, .2)',
        red10: 'rgba(242, 0, 18, .1)',
        lightRed: 'rgba(229, 46, 58, 1)',
        lighterRed: 'rgba(227, 65, 76, 1)',
        pink: 'rgba(185, 69, 191, 1)',
        darkYellow: 'rgba(171, 86, 8, 1)',
        yellow: 'rgba(246, 147, 56, 1)',
        yellow80: 'rgba(246, 147, 56, .8)',
        yellow60: 'rgba(246, 147, 56, .6)',
        yellow40: 'rgba(246, 147, 56, .4)',
        yellow20: 'rgba(246, 147, 56, .2)',
        green: 'rgba(126, 215, 111, 1)',
        green80: 'rgba(126, 215, 111, .8)',
        green60: 'rgba(126, 215, 111, .6)',
        green40: 'rgba(126, 215, 111, .4)',
        green20: 'rgba(126, 215, 111, .2)',
        green10: 'rgba(126, 215, 111, .1)',
        teal: 'rgba(56, 172, 166, 1)',
        lightGreen: 'rgba(112, 193, 67, 1)',
        lighterGreen: 'rgba(149, 196, 64, 1)',
        darkGreen: 'rgba(69, 152, 52, 1)',
        greenDark: 'rgba(69, 152, 52, 1)',
        blue: 'rgba(0, 8, 120, 1)',
        blue80: 'rgba(0, 8, 120, 0.8)',
        white: 'rgba(255, 255, 255, 1)',
        white80: 'rgba(255, 255, 255, .8)',
        white60: 'rgba(255, 255, 255, .6)',
        white40: 'rgba(255, 255, 255, .4)',
        white20: 'rgba(255, 255, 255, .2)',
        white10: 'rgba(255, 255, 255, .1)',
        neutralGradient:
            'linear-gradient(to left, rgba(202, 207, 77, 1) 0%, rgba(246, 203, 57, 1) 50%, rgba(243, 149, 61, 1) 100%)',
        neutralGradient20:
            'linear-gradient(to left, rgba(202, 207, 77, .2) 0%, rgba(246, 203, 57, .2) 50%, rgba(243, 149, 61, .2) 100%)',

        // Updated colours
        uDarkNavy: 'rgba(9, 21, 33, 1)',
        uNavy: 'rgba(0, 15, 104, 1)',
        uNavy80: 'rgba(0, 15, 104, .8)',
        uNavy60: 'rgba(0, 15, 104, .6)',
        uNavy40: 'rgba(0, 15, 104, .4)',
        uNavy20: 'rgba(0, 15, 104, .2)',
        uNavy10: 'rgba(0, 15, 104, .1)',
        uNavy05: 'rgba(0, 15, 104, .05)',

        uBlue: 'rgba(0, 31, 216, 1)',
        uBlue10: 'rgba(0, 31, 216, .1)',
        uLightGrey: 'rgba(243, 243, 244, 1)',
        uLightOrange: 'rgba(255, 241, 233, 1)',
        uLightNavy: 'rgba(218, 220, 233, 1)',

        // Body/heading text slots. Etcho's default text colour is the uNavy
        // family; branded themes may override these independently of the
        // navy surface colours (buildTheme defaults them to black).
        text: 'rgba(0, 15, 104, 1)',
        text80: 'rgba(0, 15, 104, .8)',
        text60: 'rgba(0, 15, 104, .6)',

        // Primary call-to-action slots (buttons). Etcho CTAs are navy; for
        // branded tenants buildTheme maps these to the brand primary so app
        // buttons match the branded emails.
        cta: 'rgba(0, 15, 104, 1)',
        ctaText: 'rgba(255, 255, 255, 1)',
    },
    fonts: {
        primary: {
            regular: 'ITC Avant Garde Gothic Std',
        },
        secondary: {
            regular: 'Proxima Nova',
        },
    },
    sizing: {
        xxSmall: {
            size: '10px',
            lineHeight: '14px',
        },
        xSmall: {
            size: '14px',
            lineHeight: '17px',
        },
        small: {
            size: '16px',
            lineHeight: '20px',
        },
        medium: {
            size: '18px',
            lineHeight: '21px',
        },
        large: {
            size: '24px',
            lineHeight: '30px',
        },
        xLarge: {
            size: '32px',
            lineHeight: '35px',
        },
        xxLarge: {
            size: '48px',
            lineHeight: '50px',
        },
        xxxLarge: {
            size: '72px',
            lineHeight: '72px',
        },
        xxxxLarge: {
            size: '102px',
            lineHeight: '102px',
        },
    },
    spacing: {
        xxSmall: '4px',
        xSmall: '8px',
        small: '12px',
        medium: '16px',
        large: '20px',
        xLarge: '30px',
        xxLarge: '40px',
    },
};

export default theme;

export type Theme = typeof theme;

// Replace the alpha channel of an rgba/rgb string (used to build brand tint
// ramps). Non-rgba inputs are returned unchanged.
function withAlpha(rgba: string, alpha: number): string {
    const match = rgba.match(
        /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i,
    );
    if (!match) return rgba;
    return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${alpha})`;
}

const WHITE = 'rgba(255, 255, 255, 1)';
const BLACK = 'rgba(0, 0, 0, 1)';

type BrandColorsInput = {
    primary: string; // hero/pop colour (rgba)
    primaryContrast: string;
    accent: string; // light supporting colour (tint backgrounds)
    accentContrast: string; // dark brand colour (dark surfaces + primary data)
    text?: string | null; // body text; defaults to black for print
};

/**
 * The Etcho theme with the BRAND slots swapped for another brand's colours.
 * Backgrounds and semantic colours (whites, greys, score reds/greens/yellows,
 * gradients) are untouched — PDFs keep white printable backgrounds; the brand
 * shows in highlights, charts and marks.
 *
 * Called with no/undefined branding it returns the exact default theme
 * object, so Etcho output is bit-identical.
 *
 * The input is a plain colour object (not a Tenant) on purpose: today it is
 * fed from tenant branding, but a future organisation-level branding source
 * can feed the identical machinery.
 *
 * Brands only need 3-4 colours; the hierarchy is:
 * - primary (hero/pop)   -> the orange family: highlights, dividers, stars,
 *   comparison/benchmark bars.
 * - accentContrast (dark) -> the navy families (dark surfaces, header bands)
 *   AND the uBlue portfolio-bar family, so "your portfolio" reads in the
 *   brand's dark colour against the primary pop. Skipped when white (the
 *   neutral default) — a light colour would wipe those surfaces out.
 * - accent (light)       -> uLightOrange tint backgrounds when it is a real
 *   light colour; otherwise a 10% tint of primary.
 * - text                 -> the text slots; black by default for print.
 */
export function buildTheme(
    branding?: {
        colors?: BrandColorsInput | null;
    } | null,
): Theme {
    const colors = branding?.colors;
    if (!colors) return theme;

    const primary = colors.primary;
    const dark =
        colors.accentContrast && colors.accentContrast !== WHITE
            ? colors.accentContrast
            : null;
    const lightTint =
        colors.accent && colors.accent !== WHITE
            ? colors.accent
            : withAlpha(primary, 0.1);
    const text = colors.text ?? BLACK;

    return {
        ...theme,
        colors: {
            ...theme.colors,
            // Hero/pop family (highlights, dividers, comparison bars)
            orange: primary,
            orange80: withAlpha(primary, 0.8),
            orange60: withAlpha(primary, 0.6),
            orange40: withAlpha(primary, 0.4),
            orange20: withAlpha(primary, 0.2),
            orange10: withAlpha(primary, 0.1),
            // Light tint backgrounds
            uLightOrange: lightTint,
            // Text slots (black by default — printable, configurable)
            text,
            text80: withAlpha(text, 0.8),
            text60: withAlpha(text, 0.6),
            // CTA slots follow the brand primary (matches branded emails)
            cta: primary,
            ctaText: colors.primaryContrast ?? theme.colors.ctaText,
            // Dark family (dark surfaces + portfolio-bar data colour) — only
            // when a usable dark brand colour exists
            ...(dark
                ? {
                      uBlue: dark,
                      uBlue10: withAlpha(dark, 0.1),
                      navy: dark,
                      navy10: withAlpha(dark, 0.1),
                      navy20: withAlpha(dark, 0.2),
                      navy40: withAlpha(dark, 0.4),
                      navy60: withAlpha(dark, 0.6),
                      navy80: withAlpha(dark, 0.8),
                      lightNavy: dark,
                      lightNavyHover: withAlpha(dark, 0.8),
                      uDarkNavy: dark,
                      uNavy: dark,
                      uNavy80: withAlpha(dark, 0.8),
                      uNavy60: withAlpha(dark, 0.6),
                      uNavy40: withAlpha(dark, 0.4),
                      uNavy20: withAlpha(dark, 0.2),
                      uNavy10: withAlpha(dark, 0.1),
                      uNavy05: withAlpha(dark, 0.05),
                      uLightNavy: withAlpha(dark, 0.15),
                  }
                : {}),
        },
    };
}
